export default __webpack_public_path__ + "static/media/golf.a9d27f8e.jpg";